import axios from "../utils/axios";

export const getAllStudentEnrollments = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/student-enrollments', { params });
    return data;
};
export const getStudentEnrollment = async (id) => { const { data } = await axios.get(`/student-enrollments/${id}`); return data; };
export const createStudentEnrollment = async (req) => { const { data } = await axios.post('/student-enrollments', req, { headers: { Accept: 'application/json' } }); return data; };
export const updateStudentEnrollment = async (req, id) => { const { data } = await axios.put(`/student-enrollments/${id}`, req, { headers: { Accept: 'application/json' } }); return data; };
export const deleteStudentEnrollment = async (id) => { const { data } = await axios.delete(`/student-enrollments/${id}`, { headers: { Accept: 'application/json' } }); return data; };
export const transferStudentEnrollment = async (req, id) => { const { data } = await axios.post(`/student-enrollments/${id}/transfer`, req, { headers: { Accept: 'application/json' } }); return data; };
